import { render, staticRenderFns } from "./TamanioDelete.vue?vue&type=template&id=192c5db0&"
import script from "./TamanioDelete.vue?vue&type=script&lang=js&"
export * from "./TamanioDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports